module.exports = __webpack_public_path__ + "img/globe.984e8732.svg";